import { render, staticRenderFns } from "./sirkettanitim.vue?vue&type=template&id=0eb1a63c&"
import script from "./sirkettanitim.vue?vue&type=script&lang=js&"
export * from "./sirkettanitim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports